import { render, staticRenderFns } from "./rowMenuItemShowReservationsList.vue?vue&type=template&id=5b44a586&lang=pug&"
import script from "./rowMenuItemShowReservationsList.vue?vue&type=script&lang=ts&"
export * from "./rowMenuItemShowReservationsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports